// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__22yCT","requiredAsterisk":"Info_requiredAsterisk__3ULaM"};